if($('.siteCookies__form').length) {
$('.siteCookies__buttonWrap').append($('.siteCookies__content .siteCookies__links'));
}